// Filters reference table rows by free text (part numbers, calibers, sizes).
// Matching ignores case, spaces, dots and dashes so "295 51", "295.51" and "29551" all match.
class STableFilter extends HTMLElement {
  #ac;

  connectedCallback() {
    this.#ac = new AbortController();
    const input = this.querySelector('input');
    const body = document.getElementById(this.dataset.target);
    if (!input || !body) return;
    const rows = [...body.querySelectorAll('tr')];
    const norm = (s) => s.toLowerCase().replace(/[\s.\-\/]/g, '');
    const index = rows.map((row) => norm(row.textContent || ''));
    const count = this.querySelector('[data-count]');
    const update = () => {
      const terms = input.value.split(/[\s,]+/).map(norm).filter(Boolean);
      let shown = 0;
      rows.forEach((row, i) => {
        const match = terms.every((t) => index[i].includes(t));
        row.hidden = !match;
        if (match) shown += 1;
      });
      if (count) {
        count.textContent = (this.dataset.countLabel || '')
          .replace('[shown]', String(shown))
          .replace('[total]', String(rows.length));
      }
    };
    input.addEventListener('input', update, { signal: this.#ac.signal });
    const q = new URLSearchParams(location.search).get('q');
    if (q) input.value = q;
    update();
  }

  disconnectedCallback() {
    this.#ac?.abort();
  }
}

if (!customElements.get('s-table-filter')) customElements.define('s-table-filter', STableFilter);
